import React, { useEffect, ChangeEvent, useState, useRef } from 'react';
import {
  TextField,
  Button,
  FormGroup,
  Select,
  MenuItem,
  IconButton,
  InputAdornment,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import userProfile from '../../../../assets/images/userProfile.svg';
import profileDelete from '../../../../assets/images/profileDeleteIcon.svg';
import { ExpandMore } from '@mui/icons-material';
import { ReactComponent as SearchIcon } from '../../../../assets/images/Search.svg';
import DoneIcon from '@mui/icons-material/Done';
import { useForm } from 'react-hook-form';
import CropComponent from '../../../../components/crop';
import { useAlert } from '../../../../components/Notification';
import { useHook as EquipmentsDashboard } from './useHook';
import { useSelector } from 'react-redux';
import { UrlToBase } from '../../../../components/urlToBase64';
import UnsavedChangesPopup from './UnsavedChangesPopup';
import isEqual from "lodash/isEqual";


const EquipmentsNameEdit = (props: any) => {
  const {
    fetchGetListCategory,
    createCategory,
    createSubCategory,
    editEquipment,
  } = EquipmentsDashboard();
  const { allCategory } = useSelector((state: any) => state.equipments);
 const [isUnsavedChangesDialogOpen, setIsUnsavedChangesDialogOpen] =
    useState<any>(false);
  const handleUnsavedClose = () => {
    setIsUnsavedChangesDialogOpen(false);
  };
  const { editData, handleCloseEdit, formSubmit, pagePermissionIDs } = props;
  // console.log(editData,"edit data in name")
  const canCreateCategory =
    Array.isArray(pagePermissionIDs) &&
    pagePermissionIDs.includes('categories::create');
  const canCreateSubCategory =
    Array.isArray(pagePermissionIDs) &&
    pagePermissionIDs.includes('categories::subCategoryCreate');
  const {
    register,
    handleSubmit,
    getValues,
    formState: { errors,isDirty },
  } = useForm({
    defaultValues: {
      name: editData ? editData?.equipmentName : '',
      model: editData ? editData?.model : '',
      subscription: editData ? editData?.yearlySubscriptionCost : '',
    },
  });
  const showAlert = useAlert();
  const navigate = useNavigate();
  const [profileError, setProfileError] = useState('');
  const [croppedImage, setCroppedImages] = useState<string | null>(null);
  const [opencrop, setOpenCrop] = useState(false);
  const [filteredCategory, setFilteredCategory] = useState<any[]>([]);
  const [selectedCategory, setSelectedCategory] = useState<string>('');
  const [showAllCategory, setShowAllCategory] = useState(false);
  const [filteredSubcategory, setFilteredSubcategory] = useState<any[]>([]);
  const [selectedSubcategory, setSelectedSubcategory] = useState<string>('');
  const [showAllSubcategory, setShowAllSubcategory] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const [validationErrors, setValidationErrors] = useState<
    Record<string, string>
  >({});
  const [addCategory, setAddCategory] = useState('');
  const [addSubCategory, setAddSubCategory] = useState('');
  const dropdownCategory = useRef<HTMLInputElement | null>(null);
  const dropdownSubCategory = useRef<HTMLInputElement | null>(null);
  const [openCategory, setOpenCategory] = useState(false);
  const [openSubCategory, setOpenSubCategory] = useState(false);
  const categoryInputRef = useRef<HTMLInputElement | null>(null);
  const subCategoryInputRef = useRef<HTMLInputElement | null>(null);
  const [uploadError, setUploadError] = useState('');

  const handleCloseCategory = () => {
    setOpenCategory(false);
    setShowAllCategory(false), setFilteredCategory(allCategory);
  };
  const handleCloseSubCategory = () => {
    setOpenSubCategory(false);
    setShowAllSubcategory(false), handleGetSubCategory();
  };

  const validateForm = (data: any) => {
    const errors: Record<string, string> = {};

    if (data.name.trim() === '') {
      errors.name = 'Name is required';
    }

    if (opencrop) {
      errors.uploader = 'Please upload the image';
      setUploadError('Please upload the image');
    }
    if (data.model.trim() === '') {
      errors.model = 'model is required';
    }
    if (data.subscription.trim() === '') {
      errors.subscription = 'subscription is required';
    }
    if (selectedSubcategory.trim() === '') {
      errors.subcategory = 'Subcategory is required';
    }
    if (selectedCategory.trim() === '') {
      errors.category = 'Category is required';
    }
    setValidationErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleGetCategory = async () => {
    await fetchGetListCategory({});
  };

  const handleGetSubCategory = async () => {
    const subCategory = allCategory?.find(
      (category: { categoryID: string }) =>
        category?.categoryID === selectedCategory,
    );

    if (subCategory?.subCategories) {
      setFilteredSubcategory([...new Set(subCategory?.subCategories)]);
    } else {
      setFilteredSubcategory([]);
    }
  };

  const handleCreateCategory = async () => {
    await createCategory({ categoryName: addCategory });
    setAddCategory('');
    handleGetCategory();
  };

  const handleCreateSubCategory = async () => {
    await createSubCategory({
      categoryID: selectedCategory,
      subCategoryName: addSubCategory,
    });
    setAddSubCategory('');
    handleGetCategory();
  };

  useEffect(() => {
    handleGetSubCategory();
  }, [selectedCategory, allCategory]);

  useEffect(() => {
    handleGetCategory();
  }, []);

  const handleCropComplete = (croppedImage: string) => {
    setCroppedImages(croppedImage);
    setOpenCrop(false);
    handleremoveError('uploader');
    setUploadError('');
  };

  const validateImage = (
    file: File,
    setProfileError: (error: string) => void,
  ): boolean => {
    const allowedTypes: string[] = ['image/jpeg', 'image/png', 'image/gif'];
    const maxFileSize: number = 1024 * 1024; // 1MB

    if (!allowedTypes.includes(file.type)) {
      setProfileError('Please select a JPG, GIF, or PNG file.');
      return false;
    }

    if (file.size > maxFileSize) {
      setProfileError('File size exceeds the 1MB limit.');
      return false;
    }

    return true;
  };

  const toBase64 = (file: Blob) =>
    new Promise<string>((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        if (typeof reader.result === 'string') {
          resolve(reader.result);
        } else {
          reject(new Error('Failed to read file as Data URL'));
        }
      };
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });

  const handleFileChange = async (e: ChangeEvent<HTMLInputElement>) => {
    const file: File | null = e.target.files ? e.target.files[0] : null;

    if (file && validateImage(file, setProfileError)) {
      setProfileError('');

      await toBase64(file)
        .then((base64String) => {
          // setImageString(base64String as string);
          setCroppedImages(base64String as string);
          setOpenCrop(true);
        })
        .catch(() => {
          // setImageString('');
          setCroppedImages(null);
          showAlert(`Failed to Upload Image.`, 'error');
          setOpenCrop(false);
        });
    }
    setIsActive(true);
  };
  const handleDeleteImage = () => {
    // setImageString('');
    setCroppedImages(null);
    const uploadInput = document.getElementById(
      'upload-button',
    ) as HTMLInputElement;
    if (uploadInput) {
      uploadInput.value = '';
    }
    setIsActive(true);
    handleremoveError('uploader');
    setUploadError('');
  };

  useEffect(() => {
    setFilteredCategory(allCategory);
  }, [allCategory]);

  const categorySearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    const query: string = event.target.value.trim().toLowerCase();
    const filtered: any = allCategory?.filter((user: { categoryName: any }) =>
      `${user.categoryName}`.toLowerCase().includes(query),
    );
    setFilteredCategory(filtered);
  };

  const subcategorySearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    const subCategory = allCategory?.find(
      (category: { categoryID: string }) =>
        category?.categoryID === selectedCategory,
    );
    const query: string = event.target.value.trim().toLowerCase();
    const filtered: any = subCategory?.subCategories?.filter(
      (subCategory: string) => `${subCategory}`.toLowerCase().includes(query),
    );
    setFilteredSubcategory([...new Set(filtered)]);
  };

  const userSubcategory = (userId: string): void => {
    if (selectedSubcategory === userId) {
      // setSelectedSubcategory('');
      // handleCloseSubCategory();
    } else {
      setSelectedSubcategory(userId);
    }
    handleremoveError('subcategory');
    handleActiveChange();
    handleCloseSubCategory();
  };

  const userCategory = (categoryId: string): void => {
    if (selectedCategory === categoryId) {
      // setSelectedCategory('');
      // handleCloseCategory();
    } else {
      setSelectedCategory(categoryId);
    }
    handleremoveError('category');
    handleActiveChange();
    setSelectedSubcategory('');
    handleCloseCategory();
  };

  const categoryAddMoreOption = () => {
    setShowAllCategory(true);
    // Scroll to the bottom of the popover after a short delay
    setTimeout(() => {
      const popover = dropdownCategory.current;
      if (popover) {
        popover.scrollTop = popover.scrollHeight - popover.clientHeight;
      }
      if (categoryInputRef.current) {
        categoryInputRef.current.focus();
      }
    }, 100); // Adjust the delay as needed- dropdownCategory.current.clientHeight;
  };
  const subcategoryAddMoreOption = () => {
    setShowAllSubcategory(true);
    // Scroll to the bottom of the popover after a short delay
    setTimeout(() => {
      const popover = dropdownSubCategory.current;
      if (popover) {
        popover.scrollTop = popover.scrollHeight - popover.clientHeight;
      }
      if (subCategoryInputRef.current) {
        subCategoryInputRef.current.focus();
      }
    }, 100); // Adjust the delay as needed- dropdownSubCategory.current.clientHeight;
  };
  const submitedData = async (data: any) => {
    if (validateForm(data)) {
      setIsActive(false);
      const category = allCategory?.find(
        (category: { categoryID: string }) =>
          category?.categoryID === selectedCategory,
      );

      const imageType = croppedImage?.substring(11, croppedImage?.indexOf(';'));
      const imageWithoutPrefix = croppedImage?.substring(
        croppedImage?.indexOf(',') + 1,
      );
      const equipmentPayload = {
        name: data?.name,
        model: data?.model,
        image: imageWithoutPrefix ? imageWithoutPrefix : '',
        ext: imageType ? imageType : '',
        category: category?.categoryName,
        subCategory: selectedSubcategory,
        yearlySubscriptionCost: Number(data?.subscription) || '',
      };
      if (editData) {
        const editEquipmentPayload = {
          equipmentID: editData?.equipmentID,
          equipmentName: data?.name,
          model: data?.model,
          image: imageWithoutPrefix ? imageWithoutPrefix : '',
          ext: imageType ? imageType : '',
          category: category?.categoryName,
          subCategory: selectedSubcategory,
          controller: editData?.controller,
          primaryParameter: editData?.primaryParameter,
          yearlySubscriptionCost: Number(data?.subscription) || '',
        };
        await editEquipment(editEquipmentPayload);
        handleCloseEdit();
      } else {
        formSubmit(equipmentPayload);
      }
    }
  };
  useEffect(() => {
    if (editData) {
      const imageUrl = editData?.image;
      if (imageUrl) {
        UrlToBase(imageUrl)
          .then((base64String) => {
            setCroppedImages(base64String);
          })
          .catch((error) => console.error(error));
      }
      const category = allCategory.find(
        (category: { categoryName: any }) =>
          category?.categoryName === editData?.category,
      )?.categoryID;
      setSelectedCategory(category);
      setSelectedSubcategory(editData?.subCategory);
    }
  }, [editData, allCategory]);
  const handleActiveChange = () => {
    setIsActive(true);
  };
  const handleremoveError = (name: string) => {
    if (!name) return;
    const updateError = { ...validationErrors };

    delete updateError[name];
    setValidationErrors(updateError);
  };
  return (
    <>
    
    <div className="create_controller_form">
      <form onSubmit={handleSubmit(submitedData)}>
        <div className="create_controller_form_content">
          <div className="create_controller_form_label">
            <h3>Name</h3>
          </div>
          <div className="create_controller_form_field">
            <div className="create_controller_form_field-name">
              <FormGroup>
                <TextField
                  id="name"
                  variant="outlined"
                  fullWidth
                  {...register('name')}
                  error={validationErrors.name ? true : false}
                  disabled={editData ? true : false}
                  onChange={() => {
                    handleActiveChange();
                    handleremoveError('name');
                  }}
                />
              </FormGroup>
            </div>
            {validationErrors.name && (
              <span className="text-danger">{validationErrors.name}</span>
            )}
          </div>
        </div>

        <div className="create_controller_form_content">
          <div className="create_controller_form_label">
            <h3>Image</h3>
          </div>
          <div className="create_controller_form_field">
            <div className="create_user_profile-container">
              <div className="create_user_profile">
                <div>
                  {croppedImage ? (
                    <img src={croppedImage} width={72} alt="User Profile" />
                  ) : (
                    <img src={userProfile} width={72} alt="User Profile" />
                  )}
                </div>
                <div>
                  <label htmlFor="upload-button" className="custom-file-upload">
                    Change
                  </label>
                  <input
                    type="file"
                    accept="image/*"
                    id="upload-button"
                    onChange={(e) => handleFileChange(e)}
                  />
                </div>
                <div className="imageformat">
                  <p>JPG, GIF, or PNG. 1MB Max.</p>
                </div>
              </div>
              {croppedImage && (
                <Button
                  className="create_user_profile-delete"
                  onClick={() => handleDeleteImage()}
                >
                  <img src={profileDelete} width={44} alt="delete icon" />
                </Button>
              )}
            </div>
            {profileError && (
              <span className="text-danger">{profileError}</span>
            )}
            {opencrop && croppedImage && (
              <CropComponent
                srce={croppedImage}
                onCropComplete={handleCropComplete}
                uploadError={uploadError}
              />
            )}
          </div>
        </div>

        <div className="create_controller_form_content">
          <div className="create_controller_form_label">
            <h3>Model</h3>
          </div>
          <div className="create_controller_form_field">
            <FormGroup>
              <TextField
                id="model"
                variant="outlined"
                fullWidth
                {...register('model')}
                error={validationErrors.model ? true : false}
                onChange={() => {
                  handleActiveChange();
                  handleremoveError('model');
                }}
                disabled={editData ? true : false}
              />
            </FormGroup>
            {validationErrors.model && (
              <span className="text-danger"> {validationErrors.model}</span>
            )}
          </div>
        </div>

        <div className="create_controller_form_content">
          <div className="create_controller_form_label">
            <h3>Category</h3>
          </div>
          <div className="create_controller_form_field">
            <div className="create_controller_form_field-name">
              <FormGroup>
                <Select
                  open={openCategory}
                  onOpen={() => setOpenCategory(true)}
                  fullWidth
                  multiple
                  value={filteredCategory || []}
                  IconComponent={ExpandMore}
                  renderValue={() =>
                    filteredCategory?.find(
                      (category) => category?.categoryID === selectedCategory,
                    )?.categoryName || 'Select Category'
                  }
                  onClose={() => {
                    handleCloseCategory();
                    // setShowAllCategory(false),
                    // setFilteredCategory(allCategory);
                  }}
                  error={validationErrors.category ? true : false}
                  disabled={editData ? true : false}
                >
                  <div
                    className="user_name-popover w-100"
                    ref={dropdownCategory}
                  >
                    <div className="user_name-popover-search">
                      <TextField
                        className="user_name-popover-search_input search-input"
                        variant="outlined"
                        placeholder="Search"
                        fullWidth
                        InputProps={{
                          startAdornment: (
                            <SearchIcon className="search_icon" />
                          ),
                        }}
                        onChange={categorySearch}
                      />
                    </div>
                    <div className="addcategory_container">
                      <div>
                        {filteredCategory?.map((user, index) => (
                          <Button
                            key={index}
                            onClick={() => {
                              userCategory(user.categoryID);
                            }}
                            className={
                              selectedCategory === user.categoryID
                                ? 'global_audilog_user user_checked'
                                : 'global_audilog_user'
                            }
                          >
                            <div className="global_audilog_user_profile">
                              <p>{`${user.categoryName}`}</p>
                            </div>
                            {selectedCategory === user.categoryID && (
                              <IconButton className="iconButton">
                                <DoneIcon className="doneIcon" />
                              </IconButton>
                            )}
                          </Button>
                        ))}
                        {!showAllCategory && canCreateCategory && (
                          <button
                            onClick={categoryAddMoreOption}
                            className="category_addmore_option"
                          >
                            + Add More
                          </button>
                        )}
                      </div>
                      {showAllCategory && (
                        <div className="add_category" id="showcategory">
                          <TextField
                            inputRef={categoryInputRef}
                            variant="outlined"
                            fullWidth
                            value={addCategory}
                            onChange={(e) => {
                              setAddCategory(e.target.value);
                            }}
                          />
                          <Button
                            className={
                              addCategory.trim() !== ''
                                ? 'add_save_category'
                                : 'add_disable_category'
                            }
                            disabled={addCategory.trim() === '' ? true : false}
                            onClick={handleCreateCategory}
                          >
                            Save
                          </Button>
                        </div>
                      )}
                    </div>
                  </div>
                </Select>
              </FormGroup>
            </div>
            {validationErrors.category && (
              <span className="text-danger"> {validationErrors.category}</span>
            )}
          </div>
        </div>

        <div className="create_controller_form_content">
          <div className="create_controller_form_label">
            <h3>Subcategory</h3>
          </div>
          <div className="create_controller_form_field">
            <div className="create_controller_form_field-name">
              <FormGroup>
                <Select
                  open={openSubCategory}
                  onOpen={() => setOpenSubCategory(true)}
                  fullWidth
                  multiple
                  displayEmpty
                  disabled={!selectedCategory || editData}
                  value={filteredSubcategory || []}
                  IconComponent={ExpandMore}
                  onClose={() => {
                    handleCloseSubCategory();
                    // setShowAllSubcategory(false),
                    // handleGetSubCategory();
                  }}
                  renderValue={() =>
                    filteredSubcategory?.find(
                      (subcategory) => subcategory === selectedSubcategory,
                    ) || 'Select Subcategory'
                  }
                  error={validationErrors.subcategory ? true : false}
                >
                  <div
                    className="user_name-popover w-100"
                    ref={dropdownSubCategory}
                  >
                    <div className="user_name-popover-search">
                      <TextField
                        className="user_name-popover-search_input search-input"
                        variant="outlined"
                        placeholder="Search"
                        fullWidth
                        InputProps={{
                          startAdornment: (
                            <SearchIcon className="search_icon" />
                          ),
                        }}
                        onChange={subcategorySearch}
                      />
                    </div>
                    <div className="addcategory_container">
                      <div>
                        {filteredSubcategory?.map((subcategory, index) => (
                          <Button
                            key={index}
                            onClick={() => {
                              userSubcategory(subcategory);
                            }}
                            className={
                              selectedSubcategory === subcategory
                                ? 'global_audilog_user user_checked'
                                : 'global_audilog_user'
                            }
                          >
                            <div className="global_audilog_user_profile">
                              <p>{subcategory}</p>
                            </div>
                            {selectedSubcategory === subcategory && (
                              <IconButton className="iconButton">
                                <DoneIcon className="doneIcon" />
                              </IconButton>
                            )}
                          </Button>
                        ))}
                        {!showAllSubcategory && canCreateSubCategory && (
                          <button
                            onClick={subcategoryAddMoreOption}
                            className="category_addmore_option"
                          >
                            + Add More
                          </button>
                        )}
                      </div>
                      {showAllSubcategory && (
                        <div className="add_category">
                          <TextField
                            inputRef={subCategoryInputRef}
                            variant="outlined"
                            fullWidth
                            value={addSubCategory}
                            onChange={(e) => {
                              setAddSubCategory(e.target.value);
                            }}
                          />
                          <Button
                            className={
                              addSubCategory.trim() !== ''
                                ? 'add_save_category'
                                : 'add_disable_category'
                            }
                            disabled={
                              addSubCategory.trim() === '' ? true : false
                            }
                            onClick={handleCreateSubCategory}
                          >
                            Save
                          </Button>
                        </div>
                      )}
                    </div>
                  </div>
                </Select>
              </FormGroup>
            </div>
            {validationErrors.subcategory && (
              <span className="text-danger">
                {' '}
                {validationErrors.subcategory}
              </span>
            )}
          </div>
        </div>

        <div className="create_controller_form_content">
          <div className="create_controller_form_label">
            <h3>Yearly Subscription cost</h3>
          </div>
          <div className="create_controller_form_field">
            <div className="create_controller_form_field-subscription">
              <FormGroup>
                <TextField
                  id="subscription"
                  type="number"
                  {...register('subscription')}
                  error={validationErrors.subscription ? true : false}
                  // disabled={editData ? true : false}
                  onChange={() => {
                    handleActiveChange();
                    handleremoveError('subscription');
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">₹</InputAdornment>
                    ),
                    inputProps: { min: 0, step: 0.01 },
                  }}
                  variant="outlined"
                />
              </FormGroup>
            </div>
            {validationErrors.subscription && (
              <span className="text-danger">
                {validationErrors.subscription}
              </span>
            )}
          </div>
        </div>

        <div className="create_controller_form-submit">
          <Button
            className="create_controller_form-cancel-btn"
onClick={()=>{
  const currentValues = getValues();
  const initialValues = {
      name: editData?.equipmentName || '',
      model: editData?.model || '',
      subscription: editData?.yearlySubscriptionCost || '',
    };
  if(!isEqual(currentValues, initialValues) && editData){
      // ✅ form has unsaved changes
      setIsUnsavedChangesDialogOpen(true);

  }else if (editData){
    handleCloseEdit()
  }else{
    navigate(-1)
  }
}}
           
          >
            Cancel
          </Button>
          <Button
            type="submit"
            className={
              isActive
                ? 'create_controller_form-submit-btn'
                : 'disable_controller-btn'
            }
            disabled={!isActive}
          >
            {editData ? 'Save Changes' : 'Next'}
          </Button>
        </div>
      </form>
    </div>

           <UnsavedChangesPopup
        open={isUnsavedChangesDialogOpen}
        handleClose={handleUnsavedClose}
        handleNavigateClick={handleCloseEdit}
      />
    </>
  );
};

const MemoizedComponent = React.memo(EquipmentsNameEdit);
export default MemoizedComponent;
